// extracted by mini-css-extract-plugin
export default {"geoPin":"homepage-homepage-hero-GeoPin__geoPin--1Ub4-","label":"homepage-homepage-hero-GeoPin__label--J5Pmd"};